/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 极限震撼-发送短信
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  phoneCaptchaRequest: order.PhoneCaptchaRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/captcha`,
    data: phoneCaptchaRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
